import React from "react";
import classnames from "classnames";

import Styles from "./WebV2SectionHeader.module.scss";

interface WebV2SectionHeaderProps {
    eyebrow?: string;
    title: string;
    description?: string;
    className?: string;
    titleClassName?: string;
    descriptionClassName?: string;
    align?: "center" | "left";
}

const WebV2SectionHeader = ({
    eyebrow,
    title,
    description,
    className,
    titleClassName,
    descriptionClassName,
    align = "center"
}: WebV2SectionHeaderProps) => (
    <div className={classnames(Styles.header, Styles[align], className)}>
        {eyebrow ? <p className={Styles.eyebrow}>{eyebrow}</p> : null}
        <h2 className={classnames(Styles.title, titleClassName)}>{title}</h2>
        {description ? <p className={classnames(Styles.description, descriptionClassName)}>{description}</p> : null}
    </div>
);

export default WebV2SectionHeader;
